import { useCallback, useEffect, useState } from "react";
import { isRequestCancelled } from "../../classes/utils/RequestUtils";
import { getReportsList } from "../../services/ReportService";

export function usePatientReports(patientId) {
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Internal fetch — signal is wired by the effect and by refetch()
  const fetchReports = useCallback(
    async signal => {
      if (!patientId) return;
      setLoading(true);
      setError(null);
      try {
        const data = await getReportsList(patientId, signal);
        if (!signal.aborted) setReports(data);
      } catch (err) {
        if (isRequestCancelled(err) || signal.aborted) return;
        setError(err);
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    },
    [patientId]
  );

  useEffect(() => {
    setReports(null);
    const controller = new AbortController();
    fetchReports(controller.signal);
    return () => controller.abort();
  }, [fetchReports]);

  // Public refetch — creates its own controller so callers don't need one
  const refetch = useCallback(() => {
    const controller = new AbortController();
    fetchReports(controller.signal);
  }, [fetchReports]);

  return { reports, loading, error, refetch };
}
